import { Divider, SxProps } from '@cast/design-system';

type Props = {
  sx?: SxProps;
};

export const LayoutDivider = (props: Props) => {
  return <Divider sx={{ width: '100%', ...props.sx }} />;
};
